import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import TextBoxWithTooltip from 'components/shared/textBoxWithTooltip';
import UserAvatar from 'components/shared/userAvatar';
import { isOfType } from 'utility/helpers';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    borderBottom: `1px solid ${primary.blue12}`,
    paddingBottom: spacing(8),
    marginBottom: spacing(6),
  },
  info: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gridColumnGap: 32,
    gridRowGap: 60,
  },
  label: {
    color: primary.bluish3,
    lineHeight: '20px',
    marginBottom: spacing(2),
  },
}));

const SuccessionPoolInfo = ({ translations, pool }) => {
  const classes = useStyles();
  const { owner } = pool;

  const renderUser = useCallback(
    user => <UserAvatar user={user} variant="subtitle1" caption small />,
    []
  );

  const items = [
    {
      label: translations.name,
      value: pool.name,
    },
    {
      label: translations.owner,
      value: owner ? renderUser(owner) : '-',
    },
    {
      label: translations.status,
      value: translations.statuses[pool.status],
    },
  ];

  const renderLabel = label => (
    <Typography className={classes.label} variant="body2">
      {label}
    </Typography>
  );

  const renderItem = ({ label, value }) => (
    <div key={label}>
      {renderLabel(label)}
      {isOfType(value, 'string') ? (
        <TextBoxWithTooltip variant="subtitle1" text={value} />
      ) : (
        value
      )}
    </div>
  );

  return (
    <div className={classes.root}>
      <div className={classes.info}>{items.map(renderItem)}</div>
    </div>
  );
};

SuccessionPoolInfo.propTypes = {
  translations: PropTypes.object.isRequired,
  pool: PropTypes.object.isRequired,
};

export default SuccessionPoolInfo;
